import { BusinessPlatform, ExternalChannel, Platform } from '../typings/proto';
import { getSysId } from '../business/api/report';

let commonOptions: CommonInitOptions = {
  businessPlatform: {
    channel: ExternalChannel.CHNoknok,
    sysId: getSysId(),
    platform: Platform.PlatformWeb,
  },
};

export interface CommonInitOptions {
  businessPlatform: BusinessPlatform,
}

export function initCommonOptions(options: CommonInitOptions) {
  commonOptions = options;
}

export function getCommonOptions(): CommonInitOptions {
  return commonOptions;
}
